import React, {Component} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {ModalHeader, ModalBody, ModalFooter, Modal, Button} from "reactstrap";
import {addReport} from "../actions";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import 'ladda/dist/ladda-themeless.min.css';
import ReportForm from './ReportForm';
import PropTypes from 'prop-types';

class ReportCopyButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      creating: false,
      errors: {}
    }

    this.form = React.createRef();
  }

  reportUpdate(e, data) {
    e.preventDefault();
    this.setState({creating: true});

    this.props.addReport({
      data: data.report
    }).then(() => {
      this.props.handleChange();
      this.setState({
        creating: false,
        modal: false
      })
    }).catch(e => {
      this.setState({
        creating: false,
        errors: e.response.data.form.errors
      });
    });
  }

  toggleModal(){
    this.setState({
      modal: !this.state.modal
    })
  }

  render() {
    const { creating, errors } = this.state;

    const modal = <Modal isOpen={this.state.modal} toggle={() => this.toggleModal()} size="xl">
      <ModalHeader toggle={() => this.toggleModal()} tag="h2">Kopiowanie raportu</ModalHeader>
      <hr className="my-0" />
      <ModalBody>
        <ReportForm errors={errors} onSubmit={this.reportUpdate} ref={this.form} report={this.props.report}/>
      </ModalBody>
      <ModalFooter>
        <FormattedMessage id="_.button.save">{
          (message) => <LaddaButton
            className="btn btn-primary btn-ladda"
            loading={creating}
            data-style={ZOOM_OUT}
            onClick={e => this.reportUpdate(e, this.form.current.state)}
          >
            {message}
          </LaddaButton>
        }</FormattedMessage>
        <FormattedMessage id="_.button.cancel">{
          (message) =>
            <Button color="secondary" onClick={() => this.toggleModal()}>{message}</Button>
        }</FormattedMessage>
      </ModalFooter>
    </Modal>;

    return (
      <React.Fragment>
        <Button color="primary" size="sm" onClick={() => this.toggleModal()}><i className="fas fa-copy" /> <FormattedMessage id="_.button.copy"/></Button>
        {modal}
      </React.Fragment>
    )
  }
}

ReportCopyButton.propTypes = {
  report: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired
};

export default connect(null, { addReport }, null, {forwardRef: true})(ReportCopyButton);